import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Table, Col, Row, Tooltip, Input, Form } from "antd";
import isEmpty from "lodash/isEmpty";
import scrollIntoView from "scroll-into-view";
import taskStatusCodes from "../../../lib/const/taskStatusCodes";
import { repeatIcon } from "../../../lib/icons";
import { hasAccess } from "../../RolesModule/hasAccess";
import { MENU_TASKMANAGER_WRITE } from "../../../lib/const/permissions";
import ToggleColumns from "../../ToggleableVersionsTable/ToggleColumns";
import { useParams } from "react-router";
import "./SubtasksTable.less";

function SubtasksTable(props) {
  const {
    // taskId,
    setIsModalConfirmationVisible,
    setTaskIdForReprocess,
    subtasks,
    subTasksCurrentPage,
    setSubTasksCurrentPage,
  } = props;
  const { taskTypes } = useSelector((state) => state.tasks);
  const { taskStatus } = useSelector((state) => state.rtkDictionaries);
  const [activeSubtaskId, setActiveSubtaskId] = useState(null);
  const [activeErrorSubtaskRow, setActiveErrorSubtaskRow] = useState();
  const isSubtaskWithError = (statusId) => statusId === 4;
  const [tableData, setTableData] = useState([]);
  const [currentTaskType, setCurrentTaskType] = useState(subtasks?.content?.[0]?.type);
  const [currentParameters, setCurrentParameters] = useState(
    taskTypes.content.find((item) => item.id === currentTaskType)?.parameters || []
  );

  useEffect(() => {
    setCurrentTaskType(subtasks?.content?.[0]?.type);
  }, [subtasks?.content]);

  useEffect(() => {
    setCurrentParameters(
      taskTypes.content.find((item) => item.alias === currentTaskType)?.parameters || []
    );
  }, [currentTaskType, taskTypes]);

  const [selectedIds, setselectedIds] = useState([]);

  const renderIdTitle = () => {
    const notValidRgx = /[^0-9,]/;
    const onChangeId = ({ target: { value } }) => {
      if (!notValidRgx.test(value)) {
        const activeIds = value?.split(/\D/).filter(Boolean).map(Number);
        setselectedIds(activeIds);
      }
    };

    return (
      <Tooltip title="Введите ID подзаданий через ','">
        <Form>
          <Form.Item
            name="ids"
            style={{ marginBottom: 0 }}
            className="form-item-required__hidden-error__mb0"
            rules={[
              {
                validator: (x, value) => {
                  if (value && /[^0-9,]/.test(value)) {
                    return Promise.reject();
                  }
                  return Promise.resolve();
                },
                // message: "В качестве разделителя может использоваться только запятая",
              },
            ]}
          >
            <Input placeholder="ID подзаданий" allowClear onChange={onChangeId} />
          </Form.Item>
        </Form>
      </Tooltip>
    );
  };

  renderIdTitle.toString = () => "ID подзадания";

  const { taskId } = useParams();

  const renderRestartTitle = () => {
    return (
      <Tooltip title="Перезапуск ошибочных заданий">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          role="button"
          tabIndex={-1}
          onClick={() => {
            setIsModalConfirmationVisible(true);
            setTaskIdForReprocess(taskId);
          }}
          className="repeat_icon"
        >
          {repeatIcon()}
        </div>
      </Tooltip>
    );
  };

  renderRestartTitle.toString = () => "";

  const getColumns = () => [
    {
      title: renderIdTitle,
      dataIndex: "id",
      key: "id",
      hidden: true,
      width: "10%",
    },
    {
      title: renderRestartTitle,
      key: "restartIcon",
      width: "26px",
      render(text, row) {
        if (row.statusId === 4 && hasAccess(MENU_TASKMANAGER_WRITE)) {
          return (
            <Tooltip title="Перезапуск">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
              <div
                role="button"
                tabIndex={-1}
                onClick={() => {
                  setIsModalConfirmationVisible(true);
                  setTaskIdForReprocess(row.id);
                }}
                className="repeat_icon"
              >
                {repeatIcon()}
              </div>
            </Tooltip>
          );
        }
        return null;
      },
    },
    {
      title: "Статус",
      dataIndex: "statusId",
      key: "statusId",
      width: "10%",
      render(value) {
        return taskStatus.find((item) => item.id === value).name;
      },
    },
    {
      title: "Количество попыток",
      dataIndex: "retry",
      key: "retry",
      width: "10%",
    },
    {
      title: "Ключ",
      dataIndex: "keyValue",
      key: "keyValue",
      width: "10%",
      hidden: true,
    },
    ...currentParameters.map((item) => ({
      title: item.translation,
      dataIndex: `param_${item.alias}`,
      key: `param_${item.alias}`,
      width: "20%",
      render(text, row) {
        return row.context[item.alias];
      },
    })),
  ];

  const [columns, setColumns] = useState(getColumns());

  useEffect(() => {
    setColumns(getColumns());
  }, [currentParameters, taskStatus]);

  useEffect(() => {
    if (subtasks?.content?.length > 0) {
      setTableData(
        [...(subtasks?.content || [])]
          .filter((subtask) => {
            if (selectedIds.length > 0) {
              return selectedIds.some((selectedId) =>
                String(subtask.id).startsWith(String(selectedId))
              );
            }
            return true;
          })
          .sort((a) => {
            if (a.statusId === 4) return -1;
            return 1;
          })
          .map((subtask, index) => ({
            key: subtask.id,
            id: subtask.id,
            index,
            statusId: subtask.statusId,
            context: { ...subtask.context },
            retry: subtask.retry,
            keyValue: subtask.key,
          }))
      );
    }
  }, [subtasks?.content, selectedIds]);

  const activeSubTask = subtasks?.content?.find(({ id }) => id === activeSubtaskId);
  const subTasksWithErrors = subtasks?.content?.filter(
    ({ statusId }) => String(statusId) === String(taskStatusCodes.error)
  );

  const scrollTo = (rowIndex) => {
    scrollIntoView(document.querySelector(`.scroll-row${rowIndex}`), {
      align: {
        top: 0,
      },
    });
  };

  return (
    <div className="subtaskTable" style={{ backgroundColor: "white" }}>
      {!isEmpty(subTasksWithErrors) && (
        <Row gutter={10} style={{ paddingTop: "56px" }} justify="space-between">
          <Col span={12}>
            <h4>Ошибки</h4>
            <Card style={{ height: "115px" }} bodyStyle={{ padding: "5px" }}>
              <ul
                style={{ paddingLeft: "0", height: "100px", overflow: "auto" }}
                className="list_unstyled"
              >
                {[...(subtasks?.content || [])]
                  .sort((a) => {
                    if (a.statusId === 4) return -1;
                    return 1;
                  })
                  .map(
                    ({ id, statusId, statusDescription }, i) =>
                      statusId === taskStatusCodes.error && (
                        <li key={i}>
                          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                          <span
                            className="errorMessage"
                            tabIndex={-1}
                            role="button"
                            onClick={() => {
                              setActiveSubtaskId(id);
                              setActiveErrorSubtaskRow(i);
                              scrollTo(i);
                            }}
                          >
                            {`Строка ${i + 1}: ${statusDescription}\n`}
                          </span>
                        </li>
                      )
                  )}
              </ul>
            </Card>
          </Col>
          <Col span={12}>
            <h4>Подробности:</h4>
            <Card style={{ height: "115px", overflow: "auto" }} bodyStyle={{ padding: "5px" }}>
              {activeSubTask?.statusDescription}
            </Card>
          </Col>
        </Row>
      )}
      {columns && currentTaskType && (
        <>
          <Row justify="end" style={{ marginTop: "10px" }}>
            <ToggleColumns
              tableName={`subtasks-${currentTaskType}-table`}
              columns={columns}
              setColumns={setColumns}
            />
          </Row>
          <Table
            size="small"
            columns={columns.filter(({ hidden, key }) => !hidden || key === 'restartIcon')}
            dataSource={tableData}
            scroll={{ y: "450px" }}
            className="table_no-hover"
            rowClassName={(record) => {
              if (activeErrorSubtaskRow === record.index) {
                return `scroll-row${record.index} selected-error-row`;
              }
              return isSubtaskWithError(record.statusId) ? `scroll-row${record.index}` : "";
            }}
            rowKey={(record) => record.id}
            pagination={{
              position: ["bottomCenter"],
              defaultPageSize: 20,
              hideOnSinglePage: true,
              onChange: (current) => setSubTasksCurrentPage(current),
              total: subtasks?.totalElements,
              current: subTasksCurrentPage,
              showSizeChanger: false,
            }}
          />

        </>
      )}
    </div>
  );
}

export default SubtasksTable;
